"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const TextInput_1 = __importDefault(require("./TextInput"));
const helpers_1 = require("../../lib/helpers");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const validKeys = new Set([
    '.',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
]);
function isNumberKey(evt) {
    return validKeys.has(evt.serializedKey);
}
const NumberInput = (props) => {
    const { suffix, onKeyDown: onKeyDownFromProps } = props;
    const onKeyDownHandle = react_1.useCallback((e) => {
        // we use type="text" and not type="number" due to bad mobile support with react.
        // this allows to enter "."
        // https://github.com/facebook/react/issues/1549
        if (!isNumberKey(e)) {
            e.stopPropagation();
            return;
        }
        onKeyDownFromProps === null || onKeyDownFromProps === void 0 ? void 0 : onKeyDownFromProps(e);
    }, [onKeyDownFromProps]);
    return (react_1.default.createElement(TextInput_1.default, Object.assign({ type: helpers_1.isOnMobileDevice() ? 'text' : 'number', inputMode: "numeric" }, props, { onKeyDown: onKeyDownHandle, className: classnames_1.default(props.className, { 'has-suffix': suffix }) })));
};
exports.default = withJourney_1.default('j-number-input', NumberInput);
